<template>
  <svg id="icon-search" width="20" height="20" viewBox="0 0 20 20">
    <g fill="none" fill-rule="evenodd">
      <use fill="currentColor" xlink:href="#a"/>
      <path stroke="currentColor" d="M-267.5-12.5h554v512h-554z"/>
      <g fill="currentColor" fill-rule="nonzero">
        <path d="M12.376 11.595l2.965 2.97a.55.55 0 0 1-.781.77l-2.96-2.959a4.4 4.4 0 1 1 .776-.776v-.005zM8.9 12.2a3.3 3.3 0 1 0 0-6.6 3.3 3.3 0 0 0 0 6.6z"/>
      </g>
    </g>
  </svg>
</template>
